import { useState } from 'react'
import { useSuggestions } from '@/hooks/useSuggestions'
import { SuggestionsTable } from './SuggestionsTable'
import { SuggestionDetailsDialog } from './SuggestionDetailsDialog'
import { Alert, AlertDescription } from '@brent/core-ui/ui'
import { GroupedSuggestion } from '@/types/admin'

export function SuggestionsList() {
  const { data: suggestions, isLoading, error } = useSuggestions()
  const [selectedSuggestion, setSelectedSuggestion] = useState<GroupedSuggestion | null>(null)
  const [detailsOpen, setDetailsOpen] = useState(false)

  const handleViewDetails = (suggestion: GroupedSuggestion) => {
    setSelectedSuggestion(suggestion)
    setDetailsOpen(true)
  }

  if (isLoading) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-48 animate-pulse rounded-lg bg-muted" />
        ))}
      </div>
    )
  }

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          Failed to load suggestions. {error instanceof Error ? error.message : 'Unknown error'}
        </AlertDescription>
      </Alert>
    )
  }

  if (!suggestions || suggestions.length === 0) {
    return (
      <Alert>
        <AlertDescription>No suggestions found.</AlertDescription>
      </Alert>
    )
  }

  return (
    <>
      <SuggestionsTable suggestions={suggestions} onViewDetails={handleViewDetails} />
      <SuggestionDetailsDialog
        suggestion={selectedSuggestion}
        open={detailsOpen}
        onOpenChange={setDetailsOpen}
      />
    </>
  )
}
